// Org/project roles (HS-77). Mirror of product_backend app/core/roles.py.
// Used only to show/hide UI — the backend re-checks every mutation.

export const OWNER = 'owner';
export const ADMIN = 'admin';
export const MEMBER = 'member';
export const VIEWER = 'viewer';

// Roles assignable to a project collaborator / invitee (owner is implicit).
export const ASSIGNABLE_ROLES = [ADMIN, MEMBER, VIEWER];

const RANK = { [VIEWER]: 0, [MEMBER]: 1, [ADMIN]: 2, [OWNER]: 3 };

export function roleRank(role) {
  return RANK[role] ?? -1;
}

// Owner/admin can manage members, invites, sharing.
export function isAdminRole(role) {
  return roleRank(role) >= RANK[ADMIN];
}
